/**
 * Users — shared constants. Phase 7 extract from pages/Users.jsx.
 *
 * iter-2026 — Role list is now dynamic. `ROLE_OPTIONS_FOR` falls back to
 * the hardcoded canonical list for synchronous callers, but every
 * dropdown should prefer the async `fetchAssignableRoles(orgId)` helper
 * from `@/lib/roles-registry` so custom roles created via the Roles
 * page are immediately selectable.
 */

import { ROLE_LABELS as _ROLE_LABELS, roleOptions } from "@/lib/terminology";

// Role display names come from the centralised terminology map. Custom
// roles created at runtime fall through this map via `roleLabel()`'s
// Title-Case fallback.
export const ROLE_LABELS = _ROLE_LABELS;

// Fallback role options for a non-async render path. SA can grant any
// role (including SA→SA); non-SA can only grant org_admin and below.
// Order = display order in the dropdown. For the up-to-date list
// (including custom roles) use `fetchAssignableRoles(orgId)` instead.
export const ROLE_OPTIONS_FOR = (myRole) => {
    const all = roleOptions();
    return myRole === "super_admin" ? all : all.filter((o) => o.value !== "super_admin");
};

export const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const BLANK_INVITE = { email: "", name: "", role: "viewer", org_id: "", tenant_id: "", sso_required: false, sso_provider: "" };

export const SORT_FIELDS = {
    name: (u) => (u.name || "").toLowerCase(),
    email: (u) => (u.email || "").toLowerCase(),
    role: (u) => ROLE_LABELS[u.role] || u.role,
    org_name: (u) => (u.org_name || "").toLowerCase(),
    tenant_name: (u) => (u.tenant_name || "").toLowerCase(),
    created_at: (u) => u.created_at || "",
    last_login_at: (u) => u.last_login_at || "",
    is_active: (u) => (u.is_active ? 1 : 0),
    sso_required: (u) => (u.sso_required ? 1 : 0),
};
